import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var ADD_TROLLEY_ITEM = 'ADD_TROLLEY_ITEM';
export var REMOVE_TROLLEY_ITEM = 'REMOVE_TROLLEY_ITEM';
export var UPDATE_TROLLEY_FIELD = 'UPDATE_TROLLEY_FIELD';
export var UPDATE_TROLLEY_SETUP = 'UPDATE_TROLLEY_SETUP';
export var TROLLEY_FIELD_CATENTRY_ID = 'productId';
export var TROLLEY_FIELD_LANG_ID = 'langId';
export var TROLLEY_FIELD_STORE_ID = 'storeId';
export var TROLLEY_FIELD_PARTNUMBER = 'partNumber';
export var TROLLEY_FIELD_QUANTITY = 'quantity';
export var TROLLEY_FIELD_FROM_PRODUCT = 'fromProduct';
export var TROLLEY_FIELD_TYPE = 'requestType';
export var TROLLEY_FIELD_POSTCODE = 'postCode';
export var TROLLEY_FIELD_PROMO_ID = 'promotionIdentifier';
export var TROLLEY_FIELD_PROMO_PRODUCT = 'promotionProduct';
export var TROLLEY_FIELD_HAS_PARENT_GROUP = 'hasParentProductGroup';
export var TROLLEY_FIELD_TOTAL_COUNT = 'totalProductCount';
/**
 * Fields that are allowed to be modified externally
 */

var allowedSetupFields = {
  TROLLEY_FIELD_TYPE: TROLLEY_FIELD_TYPE,
  TROLLEY_FIELD_CATENTRY_ID: TROLLEY_FIELD_CATENTRY_ID,
  TROLLEY_FIELD_FROM_PRODUCT: TROLLEY_FIELD_FROM_PRODUCT,
  TROLLEY_FIELD_PROMO_ID: TROLLEY_FIELD_PROMO_ID,
  TROLLEY_FIELD_PROMO_PRODUCT: TROLLEY_FIELD_PROMO_PRODUCT,
  TROLLEY_FIELD_HAS_PARENT_GROUP: TROLLEY_FIELD_HAS_PARENT_GROUP,
  TROLLEY_FIELD_TOTAL_COUNT: TROLLEY_FIELD_TOTAL_COUNT
};
/**
 * Update a trolley field
 * @method updateTrolleyField
 * @param  {String}  field       The field type to update
 * @param  {String}  fieldValue  The new field value
 * @return {Action}              Action of UPDATE_TROLLEY_FIELD type
 */

export var updateTrolleyField = function updateTrolleyField(partNumber, field, fieldValue) {
  return {
    type: UPDATE_TROLLEY_FIELD,
    partNumber: partNumber,
    field: field,
    fieldValue: fieldValue
  };
};
/**
 * Reduce passed setup object to valid fields
 * @method reduceValidSetup
 * @param  {Object}  final  Accumulated setup map
 * @param  {String}  field  Current field to reduce
 * @return {Object}         Modified map of setup fields
 */

var reduceValidSetup = function reduceValidSetup(setupMap) {
  return function (_final, field) {
    var allowedField = allowedSetupFields[field];

    if (allowedField) {
      return _objectSpread(_objectSpread({}, _final), {}, _defineProperty({}, allowedField, setupMap[field]));
    }

    return _final;
  };
};
/**
 * Update trolley fields with setup
 * @method updateTrolleySetup
 * @param  {String}  partNumber  The product to update the trolley for
 * @param  {Object}  setup       Setup of valid fields
 * @return {Action}              Action of
 */


export var updateTrolleySetup = function updateTrolleySetup(partNumber) {
  var setupMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var setup = Object.keys(setupMap).reduce(reduceValidSetup(setupMap), {});
  return {
    type: UPDATE_TROLLEY_SETUP,
    partNumber: partNumber,
    setup: setup
  };
};
/**
 * Add an item to the trolley state
 * @method addTrolleyItem
 * @param  {String}  partNumber  The product to add
 * @return {Action}              Action of ADD_TROLLEY_ITEM type
 */

export var addTrolleyItem = function addTrolleyItem(partNumber) {
  return {
    type: ADD_TROLLEY_ITEM,
    partNumber: partNumber
  };
};
/**
 * Remove an item from the trolley state
 * @method removeTrolleyItem
 * @param  {String}  partNumber  The product to remove
 * @return {Action}              Action of REMOVE_TROLLEY_ITEM type
 */

export var removeTrolleyItem = function removeTrolleyItem(partNumber) {
  return {
    type: REMOVE_TROLLEY_ITEM,
    partNumber: partNumber
  };
};